import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;

  form{
    width: 100%;
  }
`;

export const DrawerContent = styled.div`
  width: 100%;
  padding: 8px 0;
  display: flex;
  form{
    width: 100%;
  }
`;

export const NoResult = styled.div`
  padding: 8px 16px;
  width: 100%;
  text-align: center;
`;
